import React from 'react';
import styled from 'styled-components';

import Avatar from '@components/basics/avatar';

interface AvatarPreviewProps {
  items: { name?: string; avatar?: string }[];
  breakingIndex: number;
  noAvatar?: boolean;
  isTooltipEnabled?: boolean;
  avatarSize?: string;
}

const AvatarPreview = (props: AvatarPreviewProps) => {
  const { items } = props;

  const getMore = (index: number) => {
    if (items)
      return items?.length > props.breakingIndex &&
        index === props.breakingIndex - 1
        ? items?.length - props.breakingIndex
        : 0;
    return 0;
  };

  const getTitle = (collaboratorName: string, index: number) => {
    if (items)
      return `${collaboratorName} ${
        items.length > props.breakingIndex && index === props.breakingIndex - 1
          ? '& more'
          : ''
      }`;
    return '';
  };

  return (
    <OverlappedAvatarWrapper>
      {props.items?.map((eachItem, index: number) => {
        if (index <= props.breakingIndex - 1) {
          return (
            <OverlappedAvatar
              leftOffset={index}
              avatarSize={props.avatarSize}
              key={index}
            >
              <Avatar
                name={
                  props.noAvatar
                    ? eachItem?.name?.slice(0, 2)?.toUpperCase()
                    : ''
                }
                alt={eachItem?.name}
                isTooltipEnabled={props.isTooltipEnabled}
                key={index}
                className={`overlapped ${index !== 0 ? 'second' : ''}`}
                more={getMore(index)}
                src={eachItem.avatar}
                title={eachItem?.name && getTitle(eachItem.name, index)}
                border={true}
                size={props.avatarSize ? props.avatarSize : undefined}
              />
            </OverlappedAvatar>
          );
        }
      })}
    </OverlappedAvatarWrapper>
  );
};

export default AvatarPreview;

const OverlappedAvatarWrapper = styled.div`
  display: flex;
`;

const OverlappedAvatar = styled.div<{
  leftOffset: number;
  avatarSize?: string;
}>`
  margin-left: ${({ leftOffset, avatarSize }) =>
    leftOffset !== 0
      ? avatarSize
        ? `calc(-${avatarSize}px / 2)`
        : '-1rem'
      : 0};
  z-index: 10;
`;
